package dev.lingvo.site.components.studio.canvas

import dev.lingvo.shared.screenshots.render.ResolvedFont
import dev.lingvo.shared.screenshots.render.TextMeasurer
import dev.lingvo.shared.screenshots.render.VerticalMetrics

/** Uses the same context font and supported letter spacing as CanvasSurface, including OffscreenCanvas contexts. */
class CanvasMeasurer(private val ctx: dynamic) : TextMeasurer {
    override fun width(text: String, font: ResolvedFont, letterSpacingPx: Double): Double {
        configureFont(ctx, font, letterSpacingPx)
        return (ctx.measureText(text).width as Number).toDouble()
    }

    override fun verticalMetrics(font: ResolvedFont): VerticalMetrics {
        configureFont(ctx, font, 0.0)
        val metrics = ctx.measureText("Mg")
        return VerticalMetrics(metric(metrics.fontBoundingBoxAscent, metrics.actualBoundingBoxAscent),
            metric(metrics.fontBoundingBoxDescent, metrics.actualBoundingBoxDescent))
    }

    private fun metric(font: dynamic, actual: dynamic): Double {
        val value = if (jsTypeOf(font) == "number") (font as Number).toDouble()
            else if (jsTypeOf(actual) == "number") (actual as Number).toDouble()
            else throw IllegalStateException("Canvas text metrics are unavailable")
        require(value.isFinite()) { "Canvas text metrics must be finite" }
        return value
    }
}

internal fun configureFont(ctx: dynamic, font: ResolvedFont, letterSpacingPx: Double) {
    ctx.font = font.css
    if (jsTypeOf(ctx.letterSpacing) != "undefined") ctx.letterSpacing = "${letterSpacingPx}px"
}
